import * as actionTypes from '../actions/types';
import { getPreferences } from '../../utils';

const INITIAL_STATE = {
  entities: {},
  allIds: [],
  loading: false,
  totalCount: 0,
  preferences: getPreferences('categories'),
  error: null,
  message: null,
};

const categoriesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.LOAD_CATEGORIES: {
      return { ...state, loading: true, error: null };
    }

    case actionTypes.LOAD_CATEGORIES_SUCCESS: {
      const categories = action.payload.categories;
      const result = categories.reduce(
        (result, category) => {
          return {
            entities: {
              ...result.entities,
              [category.id]: category,
            },
            allIds: [...result.allIds, category.id],
          };
        },
        { entities: {}, allIds: [] }
      );

      return {
        ...state,
        loading: false,
        entities: result.entities,
        allIds: result.allIds,
        totalCount: action.payload.categoriesCount,
        preferences: {
          ...getPreferences('categories'), // reset filters
          ...action.payload.preferences,
        },
      };
    }

    case actionTypes.UNLOAD_CATEGORIES: {
      return {
        ...INITIAL_STATE,
      };
    }

    case actionTypes.LOAD_CATEGORIES_FAIL: {
      return { ...state, loading: false };
    }

    case actionTypes.ADD_CATEGORY:
    case actionTypes.UPDATE_CATEGORY:
    case actionTypes.REMOVE_CATEGORY: {
      return { ...state, error: null, message: null };
    }

    case actionTypes.ADD_CATEGORY_SUCCESS: {
      return {
        ...state,
        allIds: [...state.allIds, action.payload.id],
        entities: {
          ...state.entities,
          [action.payload.id]: action.payload,
        },
        message: 'A new category has been added',
      };
    }

    case actionTypes.ADD_CATEGORY_FAIL:
    case actionTypes.UPDATE_CATEGORY_FAIL:
    case actionTypes.REMOVE_CATEGORY_FAIL: {
      return { ...state, error: action.payload };
    }

    case actionTypes.UPDATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.payload.id]: action.payload,
        },
        message: 'A category has been updated',
      };
    }

    case actionTypes.REMOVE_CATEGORY_SUCCESS: {
      const deletedId = action.payload.deletedId;
      const { [deletedId]: removed, ...categories } = state.entities;
      return {
        ...state,
        allIds: state.allIds.filter((id) => id !== deletedId),
        entities: {
          ...categories,
        },
        message: 'A category has been removed',
      };
    }

    case actionTypes.CLEAR_CATEGORY_MESSAGE: {
      return { ...state, message: null };
    }

    case actionTypes.CLEAR_CATEGORY_ERROR_MESSAGE: {
      return { ...state, error: null };
    }

    case actionTypes.UPDATE_PREFERENCES: {
      const { key, subKey, value } = action.payload;
      if (key === 'categories') {
        return {
          ...state,
          preferences: { ...state.preferences, [subKey]: value },
        };
      }
      return state;
    }

    case actionTypes.RESET_PREFERENCES: {
      return { ...state, preferences: { ...action.payload.categories } };
    }

    default:
      return state;
  }
};

export default categoriesReducer;
